// src/components/EventCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import API from '../config/config'; // Updated from '../config'
import logoImage from '../assets/img/logo.png'; // Import the logo

// Add helper function for time formatting
const formatTimeDisplay = (time) => {
  if (!time || time === 'null' || time === 'undefined' || time === '') {
    return null;
  }
  
  try {
    // If it's already in HH:MM format, return as is
    if (time.match(/^\d{1,2}:\d{2}$/)) {
      const [hours, minutes] = time.split(':');
      const hour24 = parseInt(hours);
      const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
      const ampm = hour24 >= 12 ? 'PM' : 'AM';
      return `${hour12}:${minutes} ${ampm}`;
    }
    
    return null;
  } catch (error) {
    return null;
  }
};

const EventCard = ({ event, onDelete = null }) => {
  const startTime = formatTimeDisplay(event.event_time);
  const endTime = formatTimeDisplay(event.event_end_time);
  
  return (
    <div className="col-md-3 col-6 mb-4">
      <div className="event-card position-relative h-100">
        {/* Event Image */}
        <div className="event-card-img">
          <Link to={`/event/${event.id}`}>
            <img
              src={`${API.BASE_URL}/uploads/${event.event_graphic}`}
              alt={event.event_title}
              className="img-fluid w-100"
              style={{ 
                height: '200px', 
                objectFit: 'cover',
                aspectRatio: '16/9'
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = logoImage;
              }}
            />
          </Link>
          {/* Overlay Icon */}
          <div className="event-overlay-icon text-center">
            <Link to={`/event/${event.id}`}>
            </Link>
          </div>
        </div>
        
        {/* Event Details */}
        <div className="event-card-body bg_grey p-3 d-flex flex-column">
          <h5 className="event-title mb-2" style={{
            fontSize: '2rem', // Increased from 1.1rem
            fontWeight: '600', // Add font weight for better visibility
            lineHeight: '2',
            minHeight: '3.2rem', // Increased to accommodate larger font
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            <Link 
              to={`/event/${event.id}`} 
              className="text_red text-decoration-none"
              title={event.event_title} // Tooltip shows full title on hover
              style={{
                fontSize: 'inherit', // Inherit the parent font size
                fontWeight: 'inherit'
              }}
            >
              {event.event_title}
            </Link>
          </h5>
          
          <p className="event-summary mb-2 flex-grow-1" style={{
            fontSize: '0.9rem',
            lineHeight: '1.4',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#ccc'
          }}>
            {event.event_summary}
          </p>
          
          {/* Add time display if available */}
          {(startTime || endTime) && (
            <p className="event-time mb-1" style={{ fontSize: '0.85rem', color: '#aaa' }}>
              <i className="fa fa-clock-o me-1"></i>
              {startTime}
              {endTime && startTime && ' - '}
              {endTime}
            </p>
          )}
          
          <div className="mt-auto">
            <p className="event-views mb-0 text-muted" style={{ fontSize: '0.8rem' }}>
              1 Views
            </p>
            
            {/* Action Buttons (Optional) */}
            {onDelete && (
              <div className="mt-2 d-flex gap-2">
                <Link 
                  to={`/event/${event.id}`} 
                  className="btn btn-warning btn-sm flex-fill"
                  style={{ fontSize: '0.8rem' }}
                >
                  <i className="fa fa-edit me-1"></i>Edit
                </Link>
                <button
                  className="btn btn-danger btn-sm flex-fill"
                  onClick={() => onDelete(event.id)}
                  style={{ fontSize: '0.8rem' }}
                >
                  <i className="fa fa-trash me-1"></i>Delete
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// PropTypes for type checking
EventCard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number.isRequired,
    event_graphic: PropTypes.string.isRequired,
    event_title: PropTypes.string.isRequired,
    event_summary: PropTypes.string.isRequired,
    // Add other event properties if needed
  }).isRequired,
  onDelete: PropTypes.func, // Function to handle deletion
};

export default EventCard;
